// import Vue from 'vue'
//import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
// import {objectComparison} from "@/lib/lib";
import {getApiProps} from "@/lib/lib";
//const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}

export default {
    state: {
        shipmentsLocatorShipmentsIds: [],
        shipmentsLocatorShipmentsPackageId: [],
        shipmentsLocatorUnitsIds: [],
        shipmentsLocatorTokenParams: {},
    },
    actions: {
        fetchShipmentsLocatorAppUser({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentsLocatorAppUser', args, time: Date.now() / 1000})
                //const params = getApiProps('user')
                this.$api.shipmentsLocator.getAppUser(args)
                    .then((response) => {
                        let data = response.data || {}
                        commit('updateAppUser', data)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsLocatorAppUser', args, inprogress: false})
                    });
            })
        },
        fetchShipmentsLocatorShipments({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentsLocatorShipments', args, time: Date.now() / 1000})
                const params = getApiProps('locator_shipments', args)
                delete params.token;
                this.$api.shipmentsLocator.getShipments(args, params)
                    .then((response) => {
                        let data = response.data || []
                        commit('updateShipments', data)
                        commit('setShipmentsLocatorShipmentsIds', data)
                        commit('setShipmentsLiteLoad', true)
                        commit('setShipmentsFullLoad', true)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsLocatorShipments', args, inprogress: false})
                    });
            })
        },
        fetchShipmentsLocatorShipmentsPackages({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentsLocatorShipmentsPackages', args, time: Date.now() / 1000})
                const params = getApiProps('locator_shipmentsPackages', args)
                delete params.token;
                this.$api.shipmentsLocator.getShipmentsPackage(args, params)
                    .then((response) => {
                        let data = response.data || []
                        commit('updateShipmentsPackage', data)
                        commit('setShipmentsLocatorShipmentsPackageId', data)
                        commit('setShipmentsPackagesLiteLoad', true)
                        commit('setShipmentsPackagesFullLoad', true)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsLocatorShipmentsPackages', args, inprogress: false})
                    });
            })
        },
        fetchShipmentsLocatorUnits({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentsLocatorUnits', args, time: Date.now() / 1000})
                const params = getApiProps('locator_units', args)
                delete params.token;
                this.$api.shipmentsLocator.getUnits(args, params)
                    .then((response) => {
                        let data = response.data || []
                        commit('updateUnits', data)
                        commit('setShipmentsLocatorUnitsIds', data)
                        commit('setUnitsLiteLoad', true)
                        commit('setUnitsFullLoad', true)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsLocatorUnits', args, inprogress: false})
                    });
            })
        },
        fetchShipmentsLocatorUnitsLmsgs({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentsLocatorUnitsLmsgs', args, time: Date.now() / 1000})
                const params = getApiProps('locator_unitslmsgs', args)
                delete params.token;
                this.$api.shipmentsLocator.getUnitsLmsgs(args, params)
                    .then((response) => {
                        let data = response.data || []
                        commit('updateUnitsLmsgs', data)
                        commit('setUnitsLmsgsLiteLoad', true)
                        commit('setUnitsLmsgsFullLoad', true)
                        commit('setAllUnitsShowOnMap', data.map(l => l.object_id))
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsLocatorUnitsLmsgs', args, inprogress: false})
                    });
            })
        },
        fetchShipmentsLocatorUnitWeather({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token || !args.unitId) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentsLocatorUnitWeather', args, time: Date.now() / 1000})
                const params = getApiProps('locator_weathers')
                delete params.token;
                this.$api.shipmentsLocator.getUnitWeather(args.unitId, args, params)
                    .then((response) => {
                        let data = response.data
                        commit('updateWeathers', data)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsLocatorUnitWeather', args, inprogress: false})
                    });
            })
        },
        checkShipmentsLocatorToken({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'checkShipmentsLocatorToken', args, time: Date.now() / 1000})
                this.$api.shipmentsLocator.checkToken(args)
                    .then((response) => {
                        commit('setShipmentsLocatorTokenParams', response.data)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'checkShipmentsLocatorToken', args, inprogress: false})
                    });
            })
        }
    },
    mutations: {
        setShipmentsLocatorShipmentsIds(state, shipments) {
            state.shipmentsLocatorShipmentsIds = shipments.map(s => +s.id)
        },
        setShipmentsLocatorShipmentsPackageId(state, shipmentsPackages) {
            state.shipmentsLocatorShipmentsPackageId = +shipmentsPackages.id
        },
        setShipmentsLocatorUnitsIds(state, units) {
            state.shipmentsLocatorUnitsIds = units.map(u => +u.id)
        },
        setShipmentsLocatorTokenParams(state, params) {
            state.shipmentsLocatorTokenParams = {...state.shipmentsLocatorTokenParams, ...params}
            if (params.error) {
                state.shipmentsLocatorShipmentsIds = []
                state.shipmentsLocatorUnitsIds = []
            }
        },
    },
    getters: {
        getShipmentsLocatorShipmentsIds(state) {
            return state.shipmentsLocatorShipmentsIds
        },
        getshipmentsLocatorShipmentsPackageId(state) {
            return state.shipmentsLocatorShipmentsPackageId
        },
        getShipmentsLocatorUnitsIds(state) {
            return state.shipmentsLocatorUnitsIds
        },
        getShipmentsLocatorTokenParams(state) {
            return state.shipmentsLocatorTokenParams
        }
    }
}
